import { render } from "./DragPopup.vue?vue&type=template&id=4604ea81&scoped=true"
import script from "./DragPopup.vue?vue&type=script&lang=js"
export * from "./DragPopup.vue?vue&type=script&lang=js"

import "./DragPopup.vue?vue&type=style&index=0&id=4604ea81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4604ea81"]])

export default __exports__